/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: 'Gallery Product Portal',
  appShortName: 'Gallery Product Portal',
  homeAppName: 'Wind River Gallery',
  env: 'localhost',
  enableOfflineInternal: true,
  enableOfflineExternal: true,
  // disabled product list, please use release eng_name
  disabledProducts: [],

  // External links
  documentationUrl: 'https://support2.windriver.com/',
  supportUrl: 'https://support2.windriver.com/index.php?page=support&on=case',
  licensesUrl: 'https://support.windriver.com/libra/portlet_page.jsp',
  esdCenterUrl: 'https://windriver.my.site.com/support/apex/myDownload',
  offlineVideoUrl: 'https://docs.windriver.com/bundle/Wind_Share_Offline_Installation__Video_0222/page/1085128.html',
  onlineVideoUrl:
    'https://docs.windriver.com/bundle/Installing_VxWorks_7__Video_0417/page/Installing_VxWorks_7__Video_0417.html',
  syncClientVideoUrl:
    'https://docs.windriver.com/bundle/Installing_Wind_Share_Online_Sync_Client__Video_0332/page/996214.html',
  licensingUrl: 'http://www.windriver.com/licensing',
  esdSupportUrl: 'https://windriver.my.site.com/support/apex/myDownload',
  cgitUrl: 'https://git.zx2c4.com/cgit/about/',
  installLicenseUrl: 'https://docs.windriver.com/r/bundle/installation/page/Introduction',
  wrLinuxMirrorCreation:
    'https://docs.windriver.com/r/bundle/Wind_River_Linux_Getting_Started_LTS_24/page/bmi1479592556305.html',

  banner: {
    version: '1',
    title: 'New to Gallery?',
    text: 'For a demo and FAQs, click here!',
    url: 'https://docs.windriver.com/r/bundle/gallery/page/gallery_video'
  }

  // // runtime regional variable
  // domain: 'delivers-us-east-2.wrstudio.cloud',
  // harborUrl: 'https://system.registry.delivers-dev.windriver.com/',
  // galleryUrl: 'https://gallery-dev.delivers-us-east-2.wrstudio.cloud/',
  // minioUrl: 'https://artifacts.delivers-dev.windriver.com/minio/',
  // gitlabUrl: 'https://gitlab.delivers-dev.windriver.com/',

  // // API endpoints
  // apiBackendBaseUrl: 'http://localhost:3000',
  // authMsUrl: 'http://localhost:3000',
  // authMsEnable: true,

  // //New Auth Microservice update 21.06
  // tozIdRealmName: "wrai",
  // tozIdClientId: "wr-studio-sso",
  // tozIdHostName: "https://tozny.id.delivers-us-east-2.wrstudio.cloud"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
